<template>
  <section class="dp-layout mr-page-layout">
    <section class="dp-right mr-module">
      <div class="page-header">
        <div>
          <div class="header-title-bar">
            <span class="header-icon-bar"></span>
            <h3>会议列表</h3>
          </div>
          <p class="page-desc">查看、审批、取消本校会议预约；可从下方入口代订新会议</p>
        </div>
        <el-tag v-if="schoolName" type="success" size="medium" effect="plain" class="school-badge">
          <i class="el-icon-school"></i> {{ schoolName }}
        </el-tag>
        <span v-else-if="!schoolId" class="school-hint">请在顶部选择学校</span>
      </div>

      <!-- 有会议列表权限即可代订，不再单独校验代订/看板/周期三个隐藏菜单 -->
      <div v-if="schoolId" class="mr-booking-actions">
        <button type="button" class="mr-booking-action" @click="openBookingDialog('standard')">
          <span class="mr-booking-action__icon is-standard"><i class="el-icon-edit-outline"></i></span>
          <span class="mr-booking-action__body">
            <span class="mr-booking-action__title">代订会议</span>
            <span class="mr-booking-action__desc">表单创建单场会议</span>
          </span>
          <i class="el-icon-arrow-right mr-booking-action__arrow"></i>
        </button>
        <button type="button" class="mr-booking-action" @click="openBookingDialog('quick')">
          <span class="mr-booking-action__icon is-quick"><i class="el-icon-date"></i></span>
          <span class="mr-booking-action__body">
            <span class="mr-booking-action__title">日程看板代订</span>
            <span class="mr-booking-action__desc">看板点选空闲时段</span>
          </span>
          <i class="el-icon-arrow-right mr-booking-action__arrow"></i>
        </button>
        <button type="button" class="mr-booking-action" @click="openBookingDialog('recurring')">
          <span class="mr-booking-action__icon is-recurring"><i class="el-icon-refresh"></i></span>
          <span class="mr-booking-action__body">
            <span class="mr-booking-action__title">周期会议</span>
            <span class="mr-booking-action__desc">重复预约与系列管理</span>
          </span>
          <i class="el-icon-arrow-right mr-booking-action__arrow"></i>
        </button>
      </div>

      <div v-if="schoolId" class="toolbar-filter-bar">
      <el-form inline class="toolbar-filter-form"
        @submit.native.prevent="handleQuery">
        <div class="toolbar-filter-fields">
        <el-form-item label="视图">
          <el-select v-model="listTab" class="toolbar-field-w-md" @change="onListTabChange">
            <el-option v-for="item in listViewOptions" :key="item.value"
              :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="主题">
          <el-input v-model="subjectKeyword" clearable placeholder="会议主题" class="toolbar-field-w-md" />
        </el-form-item>
        <el-form-item label="预约人">
          <el-input v-model="bookerKeyword" clearable placeholder="姓名" class="toolbar-field-w-md" />
        </el-form-item>
        <el-form-item label="会议室">
          <el-select v-model="roomFilter" clearable filterable placeholder="全部" class="toolbar-field-w-md"
            :loading="roomOptionsLoading" @visible-change="loadRoomOptions">
            <el-option v-for="r in roomOptions" :key="r.Id" :label="r.Name" :value="r.Id" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="listTab === 'all'" label="状态">
          <el-select v-model="statusFilter" clearable placeholder="全部" class="toolbar-field-w-md" @change="onStatusFilterChange">
            <el-option label="全部" :value="null" />
            <el-option label="待审核" :value="10" />
            <el-option label="有效" :value="30" />
            <el-option label="已拒绝" :value="20" />
            <el-option label="爽约" :value="40" />
            <el-option label="已取消" :value="50" />
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="recurringFilter" clearable placeholder="全部" class="toolbar-field-w-md">
            <el-option label="全部" :value="null" />
            <el-option label="周期会议" value="recurring" />
            <el-option label="单场会议" value="single" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始">
          <el-date-picker v-model="startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"
            class="toolbar-field-w-date" />
        </el-form-item>
        <el-form-item label="结束">
          <el-date-picker v-model="endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"
            class="toolbar-field-w-date" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" icon="el-icon-search" native-type="submit">查询</el-button>
        </el-form-item>
        </div>
        <div class="toolbar-filter-actions">
          <el-button v-if="canExport" size="small" type="warning" icon="el-icon-download"
            :loading="exportLoading" @click="handleExport">导出</el-button>
        </div>
      </el-form>
      </div>

      <div v-if="!schoolId" class="empty-tip">请在顶部选择学校后查看会议列表</div>

      <template v-else>
                <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
                <div class="tbl-scroll-host">
                <el-table height="100%" :data="tableData" v-loading="listLoading" border size="small" class="mr-table"
          style="width: 100%;">
          <el-table-column label="会议主题" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.Subject }}</span>
              <el-tag v-if="isRecurringBooking(scope.row)" size="mini" type="warning" effect="plain"
                class="mr-recurring-tag">周期</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="RoomName" label="会议室" width="110" />
          <el-table-column prop="BookerTeacherName" label="预约人" width="90" />
          <el-table-column label="时段" min-width="220">
            <template slot-scope="scope">
              {{ formatTimeRange(scope.row.StartTime, scope.row.EndTime) }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="bookingStatusTagType(scope.row)" size="mini">
                {{ bookingStatusLabel(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" width="155" />
          <el-table-column label="操作" width="200" fixed="right" align="center">
            <template slot-scope="scope">
              <div class="table-op-pair">
                <el-button type="text" class="table-op-link" @click.stop="showDetail(scope.row)">详情</el-button>
                <el-button type="text" class="table-op-link" @click.stop="showBookingQr(scope.row)">二维码</el-button>
                <el-button
                  v-if="canCancelRow(scope.row)"
                  type="text"
                  class="table-op-link table-op-link--danger mr-row-cancel"
                  :loading="cancelingBookingId === scope.row.Id"
                  @click.stop="handleCancelRow(scope.row)"
                >取消</el-button>
                <el-button
                  v-if="canDeleteRow(scope.row)"
                  type="text"
                  class="table-op-link table-op-link--danger mr-row-delete"
                  :loading="deletingBookingId === scope.row.Id"
                  @click.stop="handleDeleteRow(scope.row)"
                >删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
                </div>

        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" :current-page="page" :page-size="pageSize"
            :total="total" style="float: right" @current-change="handlePageChange" />
        </el-col>
      </template>

      <el-dialog v-if="detailVisible" title="会议详情" :visible.sync="detailVisible" width="680px" append-to-body
        custom-class="mr-module" @closed="onDetailClosed">
        <div v-if="detailLoading" v-loading="true" style="min-height: 120px;" />
        <div v-else-if="detailData" class="mr-booking-detail">
          <div class="mr-detail-section">
            <div class="mr-detail-section__title">基本信息</div>
            <el-descriptions :column="2" size="small" border>
              <el-descriptions-item label="主题" :span="2">{{ detailData.Booking.Subject }}</el-descriptions-item>
              <el-descriptions-item label="会议室">{{ detailData.Booking.RoomName }}</el-descriptions-item>
              <el-descriptions-item label="预约人">{{ detailData.Booking.BookerTeacherName }}</el-descriptions-item>
              <el-descriptions-item label="时间" :span="2">
                {{ detailData.Booking.StartTime }} ~ {{ detailData.Booking.EndTime }}
              </el-descriptions-item>
              <el-descriptions-item label="状态">
                <el-tag :type="bookingStatusTagType(detailData.Booking)" size="mini">
                  {{ bookingStatusLabel(detailData.Booking) }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="会议类型">
                {{ isRecurringBooking(detailData.Booking) ? '周期会议场次' : '单场会议' }}
              </el-descriptions-item>
              <el-descriptions-item v-if="isRecurringBooking(detailData.Booking)" label="系列编号">
                {{ detailData.Booking.RecurringId }}
              </el-descriptions-item>
              <el-descriptions-item v-if="detailData.Booking.Remark" label="备注" :span="2">
                {{ detailData.Booking.Remark }}
              </el-descriptions-item>
            </el-descriptions>
          </div>

          <div v-if="detailParticipants.length" class="mr-detail-section mr-detail-section--participants">
            <div class="mr-detail-section__title">参会人（{{ detailParticipants.length }}）</div>
            <div class="mr-participant-toolbar">
              <el-input v-model="participantNameKeyword" size="mini" clearable
                placeholder="搜索名称" class="mr-participant-toolbar__name" @input="onParticipantFilterChange" />
              <el-select v-model="participantSignInFilter" size="mini" clearable
                placeholder="签到状态" class="mr-participant-toolbar__status"
                popper-append-to-body placement="bottom-end"
                popper-class="mr-participant-select-popper"
                @change="onParticipantFilterChange" @visible-change="onParticipantSelectVisible">
                <el-option label="已签到" value="signed" />
                <el-option label="未签到" value="unsigned" />
                <el-option label="不适用" value="na" />
              </el-select>
            </div>
            <el-table :data="paginatedDetailParticipants" size="mini" border
              class="mr-participant-table" style="width: 100%;">
              <el-table-column label="类型" width="64">
                <template slot-scope="scope">{{ participantTypeText(scope.row.ParticipantType) }}</template>
              </el-table-column>
              <el-table-column label="名称" min-width="96" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.ParticipantName || '—' }}</template>
              </el-table-column>
              <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                  <el-tag :type="participantSignInTagType(scope.row)" size="mini" effect="plain">
                    {{ participantSignInStatusText(scope.row) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="签到时间" width="132" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.SignInTime">{{ scope.row.SignInTime }}</span>
                  <span v-else class="mr-detail-muted">—</span>
                </template>
              </el-table-column>
              <template slot="empty">
                <span class="mr-detail-empty">{{ participantEmptyText }}</span>
              </template>
            </el-table>
            <div v-if="filteredDetailParticipants.length > participantPageSize" class="mr-participant-pager">
              <el-pagination small layout="total, prev, pager, next"
                :current-page="participantPage" :page-size="participantPageSize"
                :total="filteredDetailParticipants.length"
                @current-change="onParticipantPageChange" />
            </div>
          </div>

          <div v-if="detailApprovalSteps.length" class="mr-detail-section">
            <div class="mr-detail-section__title">审批进度</div>
            <el-steps :active="approvalActiveStep" finish-status="success" align-center size="small">
              <el-step v-for="step in detailApprovalSteps" :key="step.StepNumber"
                :title="`第${step.StepNumber}步`"
                :description="approvalStepDesc(step)"
                :status="approvalStepStatus(step)" />
            </el-steps>
          </div>

          <div v-if="detailExtraSignIns.length" class="mr-detail-section">
            <div class="mr-detail-section__title">其他签到（{{ detailExtraSignIns.length }}）</div>
            <el-table :data="detailExtraSignIns" size="mini" border max-height="140">
              <el-table-column prop="TeacherName" label="签到人" min-width="100" />
              <el-table-column prop="SignInTime" label="签到时间" width="155" />
            </el-table>
          </div>

          <div class="mr-detail-actions">
            <el-button size="small" @click="showBookingQr()">预约二维码</el-button>
            <el-button v-if="canCancelRecurringSeries" type="danger" size="small" plain
              @click="handleCancelRecurringSeries">取消整系列</el-button>
            <el-button v-if="canCancel" type="warning" size="small" @click="handleCancel">取消会议</el-button>
            <el-button v-if="canDeleteDetail" type="danger" size="small" plain
              :loading="deletingBookingId === currentBookingId" @click="handleDeleteDetail">删除会议</el-button>
            <el-button v-if="canApprove" type="success" size="small" @click="submitAudit(true)">通过</el-button>
            <el-button v-if="canReject" type="danger" size="small" @click="submitAudit(false)">驳回</el-button>
          </div>
        </div>
      </el-dialog>

      <MeetingRoomQrDialog
        v-if="qrVisible"
        :visible.sync="qrVisible"
        :loading="qrLoading"
        :qr-data="qrData"
        title="预约二维码"
        download-prefix="会议预约二维码" />

      <el-dialog title="代订会议" :visible.sync="standardDialogVisible" width="720px" top="4vh"
        :close-on-click-modal="false" append-to-body custom-class="mr-booking-dialog mr-booking-dialog--standard" destroy-on-close>
        <MeetingStandardBooking v-if="standardDialogVisible" embedded
          @success="onBookingSuccess" @cancel="standardDialogVisible = false" />
      </el-dialog>

      <el-dialog title="日程看板代订" :visible.sync="quickDialogVisible" width="1000px" top="4vh"
        :close-on-click-modal="false" append-to-body custom-class="mr-booking-dialog mr-booking-dialog--wide" destroy-on-close>
        <MeetingQuickBooking v-if="quickDialogVisible" embedded
          @success="onBookingSuccess" @cancel="quickDialogVisible = false" />
      </el-dialog>

      <el-dialog title="周期会议" :visible.sync="recurringDialogVisible" width="1000px" top="4vh"
        :close-on-click-modal="false" append-to-body custom-class="mr-booking-dialog mr-booking-dialog--wide mr-booking-dialog--tall dialog-fixed-height" destroy-on-close>
        <MeetingRecurringBooking v-if="recurringDialogVisible" embedded
          @success="onBookingSuccess" @cancel="recurringDialogVisible = false" />
      </el-dialog>
    </section>
  </section>
</template>

<script>
import axios from 'axios';
import { BaseApiUrl } from '../../api/base';
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps';
import { getMeetingBookingQr } from '../../api/meetingRoomApi';
import { getButtonList } from '../../utils/routeButtonList';

const apiBase = BaseApiUrl;

function todayStr() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function defaultDateRange() {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 1);
  const fmt = d => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };
  return { startDate: fmt(start), endDate: fmt(end) };
}

export default {
  name: 'MeetingBookingList',
  components: {
    MeetingRoomQrDialog: () => import('../../components/MeetingRoomQrDialog.vue'),
    MeetingStandardBooking: () => import('./StandardBooking.vue'),
    MeetingQuickBooking: () => import('./QuickBooking.vue'),
    MeetingRecurringBooking: () => import('./RecurringBooking.vue')
  },
  data() {
    const dr = defaultDateRange();
    return {
      listTab: 'all',
      pendingCount: 0,
      subjectKeyword: '',
      bookerKeyword: '',
      roomFilter: null,
      statusFilter: null,
      recurringFilter: null,
      displayStatusFilter: '',
      startDate: dr.startDate,
      endDate: dr.endDate,
      tableData: [],
      listLoading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      roomOptions: [],
      roomOptionsLoading: false,
      roomLoadedForSchool: null,
      detailVisible: false,
      detailLoading: false,
      detailData: null,
      currentBookingId: 0,
      listSeq: 0,
      buttonList: [],
      qrVisible: false,
      qrLoading: false,
      qrData: null,
      menuRouters: [],
      standardDialogVisible: false,
      quickDialogVisible: false,
      recurringDialogVisible: false,
      exportLoading: false,
      cancelingBookingId: 0,
      deletingBookingId: 0,
      participantNameKeyword: '',
      participantSignInFilter: '',
      participantPage: 1,
      participantPageSize: 6
    };
  },
  computed: {
    schoolId() {
      return resolveActiveSchoolId(this);
    },
    schoolName() {
      return this.$store.state.activeSchoolName || '';
    },
    canExport() {
      return (this.buttonList || []).some(b => b.Func === 'handleExport');
    },
    listViewOptions() {
      const pendingLabel = this.pendingCount > 0 ? `待审核 (${this.pendingCount})` : '待审核';
      return [
        { label: '全部', value: 'all' },
        { label: pendingLabel, value: 'pending' },
        { label: '今日会议', value: 'today' },
        { label: '进行中', value: 'ongoing' }
      ];
    },
    canCancel() {
      return this.detailData && (this.detailData.AvailableActions || []).includes('cancel');
    },
    canApprove() {
      return this.detailData && (this.detailData.AvailableActions || []).includes('approve');
    },
    canReject() {
      return this.detailData && (this.detailData.AvailableActions || []).includes('reject');
    },
    canCancelRecurringSeries() {
      return this.detailData && (this.detailData.AvailableActions || []).includes('cancelRecurringSeries');
    },
    canDeleteDetail() {
      return this.detailData && this.detailData.Booking && this.canDeleteRow(this.detailData.Booking);
    },
    detailParticipants() {
      return (this.detailData && this.detailData.Participants) || [];
    },
    detailParticipantRows() {
      const signInMap = {};
      this.detailSignIns.forEach(item => {
        const key = String(item.TeacherMasterId);
        if (!signInMap[key] || item.SignInTime < signInMap[key]) {
          signInMap[key] = item.SignInTime;
        }
      });
      return this.detailParticipants.map(participant => {
        const isTeacher = participant.ParticipantType === 1;
        const signInTime = isTeacher ? (signInMap[String(participant.ParticipantId)] || '') : '';
        let signInStatus = 'na';
        if (isTeacher) signInStatus = signInTime ? 'signed' : 'unsigned';
        return {
          ...participant,
          SignInTime: signInTime,
          SignInStatus: signInStatus
        };
      });
    },
    filteredDetailParticipants() {
      const keyword = (this.participantNameKeyword || '').trim().toLowerCase();
      return this.detailParticipantRows.filter(row => {
        if (keyword) {
          const name = (row.ParticipantName || '').toLowerCase();
          if (!name.includes(keyword)) return false;
        }
        if (this.participantSignInFilter && row.SignInStatus !== this.participantSignInFilter) return false;
        return true;
      });
    },
    paginatedDetailParticipants() {
      const start = (this.participantPage - 1) * this.participantPageSize;
      return this.filteredDetailParticipants.slice(start, start + this.participantPageSize);
    },
    participantEmptyText() {
      if ((this.participantNameKeyword || '').trim() || this.participantSignInFilter) {
        return '无匹配的参会人';
      }
      return '暂无参会人';
    },
    detailExtraSignIns() {
      const participantTeacherIds = new Set(
        this.detailParticipants
          .filter(p => p.ParticipantType === 1)
          .map(p => String(p.ParticipantId))
      );
      return this.detailSignIns.filter(s => !participantTeacherIds.has(String(s.TeacherMasterId)));
    },
    detailApprovalSteps() {
      return (this.detailData && this.detailData.ApprovalSteps) || [];
    },
    detailSignIns() {
      return (this.detailData && this.detailData.SignIns) || [];
    },
    approvalActiveStep() {
      const steps = this.detailApprovalSteps;
      if (!steps.length) return 0;
      const rejected = steps.findIndex(s => s.Status === 'Rejected');
      if (rejected >= 0) return rejected;
      const pending = steps.findIndex(s => s.Status === 'Pending');
      if (pending >= 0) return pending;
      return steps.length;
    }
  },
  watch: {
    schoolId(val, oldVal) {
      if (!val || val === oldVal) return;
      this.page = 1;
      this.roomLoadedForSchool = null;
      this.roomOptions = [];
      this.loadPendingCount();
      this.loadList();
    },
    '$route.query': {
      immediate: false,
      handler(query) {
        this.applyRouteQuery(query || {});
      }
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.menuRouters = routers;
    this.buttonList = getButtonList(this.$route.path, routers);
    this.applyRouteQuery(this.$route.query || {});
    if (this.schoolId) {
      this.loadPendingCount();
      this.loadList();
    }
  },
  methods: {
    openBookingDialog(type) {
      if (type === 'standard') this.standardDialogVisible = true;
      else if (type === 'quick') this.quickDialogVisible = true;
      else if (type === 'recurring') this.recurringDialogVisible = true;
    },
    onBookingSuccess() {
      this.loadList();
      this.loadPendingCount();
    },
    applyRouteQuery(query) {
      if (query.tab) {
        this.listTab = query.tab;
        this.applyListTabFilters(query.tab, false);
      }
      if (query.status) {
        this.statusFilter = Number(query.status) || null;
        this.listTab = this.statusFilter === 10 ? 'pending' : 'all';
      }
      if (query.roomId) {
        this.roomFilter = Number(query.roomId) || null;
      }
    },
    onListTabChange(tab) {
      this.applyListTabFilters(tab, true);
    },
    applyListTabFilters(tab, reload) {
      const today = todayStr();
      this.displayStatusFilter = '';
      if (tab === 'pending') {
        this.statusFilter = 10;
        const dr = defaultDateRange();
        this.startDate = dr.startDate;
        this.endDate = dr.endDate;
      } else if (tab === 'today') {
        this.statusFilter = null;
        this.startDate = today;
        this.endDate = today;
      } else if (tab === 'ongoing') {
        this.statusFilter = null;
        this.displayStatusFilter = 'ongoing';
        const dr = defaultDateRange();
        this.startDate = dr.startDate;
        this.endDate = dr.endDate;
      } else {
        this.statusFilter = null;
        const dr = defaultDateRange();
        this.startDate = dr.startDate;
        this.endDate = dr.endDate;
      }
      if (reload) {
        this.page = 1;
        this.loadList();
      }
    },
    onStatusFilterChange(val) {
      if (val === 10) this.listTab = 'pending';
      else if (this.listTab === 'pending') this.listTab = 'all';
    },
    loadRoomOptions(visible) {
      if (!visible || !this.schoolId || this.roomOptionsLoading) return;
      if (this.roomLoadedForSchool === this.schoolId && this.roomOptions.length) return;
      this.roomOptionsLoading = true;
      axios.get(`${apiBase}/api/MeetingRoom/GetList`, {
        params: { page: 1, intPageSize: 200, departmentId: this.schoolId }
      }).then(res => {
        this.roomOptionsLoading = false;
        this.roomLoadedForSchool = this.schoolId;
        this.roomOptions = (res.data.success && res.data.response && res.data.response.data) || [];
      }).catch(() => { this.roomOptionsLoading = false; });
    },
    loadPendingCount() {
      if (!this.schoolId) {
        this.pendingCount = 0;
        return;
      }
      const dr = defaultDateRange();
      axios.get(`${apiBase}/api/MeetingRoomDashboard/GetStats`, {
        params: {
          schoolId: this.schoolId,
          campusId: 0,
          startDate: dr.startDate,
          endDate: dr.endDate,
          groupBy: 'day'
        }
      }).then(res => {
        if (res.data.success && res.data.response) {
          this.pendingCount = res.data.response.PendingBookings || 0;
        }
      }).catch(() => {});
    },
    buildListParams() {
      const para = {
        page: this.page,
        pageSize: this.pageSize,
        schoolId: this.schoolId,
        bookerKeyword: this.bookerKeyword || '',
        subjectKeyword: this.subjectKeyword || '',
        startDate: this.startDate || '',
        endDate: this.endDate || ''
      };
      if (this.roomFilter) para.roomId = this.roomFilter;
      if (this.statusFilter != null && this.statusFilter !== '') para.status = this.statusFilter;
      if (this.displayStatusFilter) para.displayStatus = this.displayStatusFilter;
      if (this.recurringFilter === 'recurring') para.recurringOnly = true;
      else if (this.recurringFilter === 'single') para.recurringOnly = false;
      return para;
    },
    loadList() {
      if (!this.schoolId) return;
      const seq = ++this.listSeq;
      this.listLoading = true;
      axios.get(`${apiBase}/api/MeetingBooking/GetList`, {
        params: this.buildListParams()
      }).then(res => {
        if (seq !== this.listSeq) return;
        this.listLoading = false;
        if (res.data && res.data.success) {
          this.tableData = (res.data.response && res.data.response.data) || [];
          this.total = (res.data.response && res.data.response.dataCount) || 0;
        }
      }).catch(() => {
        if (seq !== this.listSeq) return;
        this.listLoading = false;
      });
    },
    handleQuery() {
      this.page = 1;
      this.loadList();
      this.loadPendingCount();
    },
    handlePageChange(val) {
      const next = Number(val);
      if (!next || next === this.page) return;
      this.page = next;
      this.loadList();
    },
    handleExport() {
      if (!this.schoolId) return;
      const para = this.buildListParams();
      delete para.page;
      delete para.pageSize;
      return axios.get(`${apiBase}/api/MeetingBooking/Export`, {
        params: para,
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `会议记录导出_${Date.now()}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.$message.success('导出成功，文件已开始下载');
      }).catch(() => {
        this.$message.error('导出失败');
      });
    },
    showDetail(row) {
      this.currentBookingId = row.Id;
      this.detailVisible = true;
      this.detailLoading = true;
      this.detailData = null;
      this.resetParticipantFilters();
      axios.get(`${apiBase}/api/MeetingBooking/GetDetail`, { params: { id: row.Id } })
        .then(res => {
          this.detailLoading = false;
          if (res.data.success) {
            this.detailData = res.data.response;
          } else {
            this.$message.error(res.data.msg || '加载失败');
          }
        }).catch(() => { this.detailLoading = false; });
    },
    onDetailClosed() {
      this.detailData = null;
      this.detailLoading = false;
      this.currentBookingId = 0;
      this.resetParticipantFilters();
    },
    resetParticipantFilters() {
      this.participantNameKeyword = '';
      this.participantSignInFilter = '';
      this.participantPage = 1;
    },
    onParticipantFilterChange() {
      this.participantPage = 1;
    },
    onParticipantPageChange(page) {
      this.participantPage = page;
    },
    onParticipantSelectVisible(visible) {
      if (visible) return;
      this.$nextTick(() => {
        const detailEl = this.$el && this.$el.querySelector('.mr-booking-detail');
        if (detailEl) detailEl.scrollLeft = 0;
      });
    },
    /** 展示预约二维码；可从列表行或详情内调用。最后更新：2026-07-14 */
    showBookingQr(row) {
      const bookingId = (row && row.Id) || this.currentBookingId;
      if (!bookingId) return;
      const subject = (row && row.Subject)
        || (this.detailData && this.detailData.Booking && this.detailData.Booking.Subject)
        || '';
      const roomName = (row && row.RoomName)
        || (this.detailData && this.detailData.Booking && this.detailData.Booking.RoomName)
        || '';
      this.qrVisible = true;
      this.qrLoading = true;
      this.qrData = null;
      getMeetingBookingQr(bookingId).then(res => {
        this.qrLoading = false;
        if (res.data.success) {
          const data = res.data.response || {};
          this.qrData = {
            ...data,
            Subject: subject,
            RoomName: roomName
          };
        } else {
          this.$message.error(res.data.msg || '获取二维码失败');
          this.qrVisible = false;
        }
      }).catch(() => {
        this.qrLoading = false;
        this.qrVisible = false;
      });
    },
    handleCancel() {
      if (!this.currentBookingId) return;
      const subject = this.detailData && this.detailData.Booking && this.detailData.Booking.Subject;
      this.cancelBookingById(this.currentBookingId, subject);
    },
    canCancelRow(row) {
      if (!row) return false;
      const status = Number(row.Status);
      if (status !== 10 && status !== 30) return false;
      return row.DisplayStatus !== 'ended';
    },
    /** 已取消/已拒绝/爽约，或已结束的会议可软删除 */
    canDeleteRow(row) {
      if (!row) return false;
      const status = Number(row.Status);
      if (status === 20 || status === 40 || status === 50) return true;
      return row.DisplayStatus === 'ended';
    },
    handleCancelRow(row) {
      if (!row || !this.canCancelRow(row)) return;
      this.cancelBookingById(row.Id, row.Subject);
    },
    handleDeleteRow(row) {
      if (!row || !this.canDeleteRow(row)) return;
      this.deleteBookingById(row.Id, row.Subject);
    },
    handleDeleteDetail() {
      if (!this.currentBookingId || !this.canDeleteDetail) return;
      const subject = this.detailData && this.detailData.Booking && this.detailData.Booking.Subject;
      this.deleteBookingById(this.currentBookingId, subject);
    },
    deleteBookingById(bookingId, subject) {
      if (!bookingId || this.deletingBookingId) return;
      const label = subject || '该会议';
      this.$confirm(`确认删除「${label}」？`, '提示', { type: 'warning' }).then(() => {
        this.deletingBookingId = bookingId;
        axios.post(`${apiBase}/api/MeetingBooking/Delete`, null, {
          params: { bookingId }
        }).then(res => {
          this.deletingBookingId = 0;
          if (res.data.success) {
            this.$message.success('删除成功');
            this.detailVisible = false;
            this.loadList();
            this.loadPendingCount();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        }).catch(() => { this.deletingBookingId = 0; });
      }).catch(() => {});
    },
    cancelBookingById(bookingId, subject) {
      if (!bookingId || this.cancelingBookingId) return;
      const label = subject || '该会议';
      this.$confirm(`确认取消「${label}」？`, '提示', { type: 'warning' }).then(() => {
        this.cancelingBookingId = bookingId;
        axios.post(`${apiBase}/api/MeetingBooking/Cancel`, null, {
          params: { bookingId }
        }).then(res => {
          this.cancelingBookingId = 0;
          if (res.data.success) {
            this.$message.success('取消成功');
            this.detailVisible = false;
            this.loadList();
            this.loadPendingCount();
          } else {
            this.$message.error(res.data.msg || '取消失败');
          }
        }).catch(() => { this.cancelingBookingId = 0; });
      }).catch(() => {});
    },
    handleCancelRecurringSeries() {
      const recurringId = this.detailData && this.detailData.Booking && this.detailData.Booking.RecurringId;
      if (!recurringId) return;
      this.$confirm('确认取消该周期系列的全部未开始会议？', '提示', { type: 'warning' }).then(() => {
        axios.post(`${apiBase}/api/MeetingBooking/CancelRecurring`, null, {
          params: { recurringId }
        }).then(res => {
          if (res.data.success) {
            this.$message.success(res.data.msg || '取消成功');
            this.detailVisible = false;
            this.loadList();
            this.loadPendingCount();
          } else {
            this.$message.error(res.data.msg || '取消失败');
          }
        });
      }).catch(() => {});
    },
    isRecurringBooking(row) {
      return row && Number(row.RecurringId) > 0;
    },
    submitAudit(approve) {
      const doSubmit = (comments) => {
        const url = approve
          ? `${apiBase}/api/MeetingBooking/Approve`
          : `${apiBase}/api/MeetingBooking/Reject`;
        axios.post(url, { bookingId: this.currentBookingId, comments: comments || '' }).then(res => {
          if (res.data.success) {
            this.$message.success(res.data.msg || '操作成功');
            this.detailVisible = false;
            this.loadList();
            this.loadPendingCount();
          } else {
            this.$message.error(res.data.msg || '操作失败');
          }
        });
      };
      if (approve) {
        this.$prompt('审批意见（可选）', '审批通过', {
          confirmButtonText: '通过',
          cancelButtonText: '取消',
          inputPlaceholder: '可选填写意见'
        }).then(({ value }) => doSubmit(value)).catch(() => {});
      } else {
        this.$prompt('请填写驳回原因', '审批驳回', {
          confirmButtonText: '驳回',
          cancelButtonText: '取消',
          inputPlaceholder: '必填',
          inputValidator: v => !!(v && String(v).trim()) || '请填写驳回原因'
        }).then(({ value }) => doSubmit(value)).catch(() => {});
      }
    },
    formatTimeRange(start, end) {
      if (!start) return '-';
      const s = String(start).replace('T', ' ').slice(0, 16);
      const e = end ? String(end).replace('T', ' ').slice(11, 16) : '';
      return e ? `${s} ~ ${e}` : s;
    },
    statusText(status) {
      const map = { 10: '待审核', 20: '已拒绝', 30: '有效', 40: '爽约', 50: '已取消' };
      return map[status] || status;
    },
    statusTagType(status) {
      // 待审橙 / 拒绝红 / 有效绿 / 爽约红 / 取消橙（与「已结束」灰区分）
      const map = { 10: 'warning', 20: 'danger', 30: 'success', 40: 'danger', 50: 'warning' };
      return map[status] || 'info';
    },
    displayStatusText(val) {
      const map = { upcoming: '未开始', ongoing: '进行中', ended: '已结束' };
      return map[val] || val || '-';
    },
    /** 有效预约按时间展示未开始/进行中/已结束，终态直接展示业务状态。最后更新：2026-07-18 */
    bookingStatusLabel(row) {
      if (!row) return '-';
      const status = Number(row.Status);
      if (status === 30) return this.displayStatusText(row.DisplayStatus);
      return this.statusText(status);
    },
    bookingStatusTagType(row) {
      if (!row) return 'info';
      const status = Number(row.Status);
      if (status === 30) {
        // 未开始蓝 / 进行中绿 / 已结束灰
        const map = { upcoming: '', ongoing: 'success', ended: 'info' };
        return map[row.DisplayStatus] !== undefined ? map[row.DisplayStatus] : 'success';
      }
      return this.statusTagType(status);
    },
    participantTypeText(type) {
      const map = { 1: '教师', 2: '学生', 3: '部门', 4: '班级' };
      return map[type] || type;
    },
    participantSignInStatusText(row) {
      const map = { signed: '已签到', unsigned: '未签到', na: '不适用' };
      return map[row.SignInStatus] || '—';
    },
    participantSignInTagType(row) {
      const map = { signed: 'success', unsigned: 'info', na: '' };
      return map[row.SignInStatus] || 'info';
    },
    approvalStepDesc(step) {
      const name = step.ApproverName || '';
      const statusMap = { Pending: '待审', Approved: '已通过', Rejected: '已驳回', Cancel: '已取消' };
      const st = statusMap[step.Status] || step.Status;
      return name ? `${name} · ${st}` : st;
    },
    approvalStepStatus(step) {
      if (step.Status === 'Approved') return 'success';
      if (step.Status === 'Rejected') return 'error';
      if (step.Status === 'Pending') return 'wait';
      return 'finish';
    }
  }
};
</script>

<style scoped>
.mr-booking-detail {
  max-height: 65vh;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.mr-detail-section {
  margin-bottom: 16px;
  min-width: 0;
}
.mr-detail-section--participants {
  overflow: hidden;
}
.mr-detail-section__title {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}
.mr-detail-muted {
  color: #94a3b8;
}
.mr-participant-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  min-width: 0;
}
.mr-participant-toolbar__name {
  width: 160px;
  flex: 0 0 160px;
}
.mr-participant-toolbar__name >>> .el-input {
  width: 160px;
}
.mr-participant-toolbar__status {
  width: 120px;
  flex: 0 0 120px;
}
.mr-participant-toolbar__status >>> .el-input {
  width: 120px;
}
.mr-participant-table >>> .el-table__body-wrapper {
  overflow-x: hidden;
}
.mr-participant-table >>> table {
  width: 100% !important;
  table-layout: fixed;
}
.mr-participant-pager {
  margin-top: 8px;
  text-align: right;
  min-height: 28px;
}
.mr-detail-empty {
  display: block;
  padding: 16px 0;
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
}
.mr-detail-actions {
  margin-top: 16px;
  text-align: right;
}
.mr-booking-actions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: -4px 0 16px;
}
.mr-booking-action {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
.mr-booking-action:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 14px rgba(30, 58, 138, 0.1);
  transform: translateY(-1px);
}
.mr-booking-action:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}
.mr-booking-action__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 18px;
}
.mr-booking-action__icon.is-standard {
  color: #1d4ed8;
  background: #eff6ff;
}
.mr-booking-action__icon.is-quick {
  color: #059669;
  background: #ecfdf5;
}
.mr-booking-action__icon.is-recurring {
  color: #d97706;
  background: #fffbeb;
}
.mr-booking-action__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.mr-booking-action__title {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.3;
}
.mr-booking-action__desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}
.mr-booking-action__arrow {
  flex-shrink: 0;
  font-size: 14px;
  color: #94a3b8;
  transition: color 0.2s ease, transform 0.2s ease;
}
.mr-booking-action:hover .mr-booking-action__arrow {
  color: #3b82f6;
  transform: translateX(2px);
}
.mr-recurring-tag {
  margin-left: 6px;
  vertical-align: middle;
}
.el-button--text.mr-row-cancel {
  color: #e6a23c;
}
.el-button--text.mr-row-cancel:hover,
.el-button--text.mr-row-cancel:focus {
  color: #cf9236;
}
/* 与详情「删除会议」危险色一致，覆盖 el-button--text 默认蓝 */
.el-button--text.mr-row-delete {
  color: #f56c6c;
}
.el-button--text.mr-row-delete:hover,
.el-button--text.mr-row-delete:focus {
  color: #f78989;
}
@media (max-width: 900px) {
  .mr-booking-actions {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
.mr-participant-select-popper {
  z-index: 4000 !important;
}
</style>
